import { gql } from 'graphql-tag';

export const AD_TARGETING_FRAGMENT = gql`
    fragment AD_TARGETING_FRAGMENT on AdTargeting {
        activity
        areaName
        bedsMax
        bedsMin
        brand
        brandPrimary
        countyAreaName
        countryCode
        currencyCode
        listingsCategory
        outcode
        outcodes
        page
        postalArea
        priceMax
        priceMin
        propertyType
        regionName
        resultsSort
        searchLocation
        searchResultsCount
        section
        totalResults
        url
        viewType
    }
`;
